export const APP_STORE_URL = 'https://apps.apple.com/us/app/creator-voice/id6754109753';

export const HERO = {
  headline: 'Your Voice Is Telling\nSecrets.',
  subheadline: 'Everyone hears them. You don\'t. Until now.',
  cta: 'Download Free',
  socialProof: '2,000+ people discovered their voice',
};

export const PROBLEM = {
  headline: 'The Gap You Can\'t Hear',
  stats: [
    { value: '0.5s', label: 'to form a first impression from voice alone' },
    { value: '93%', label: 'of communication is non-verbal — tone, pace, energy' },
    { value: '0', label: 'tools existed to measure it. Until now.' },
  ],
  body: 'Every meeting. Every call. Every recording. Your voice broadcasts confidence, nervousness, warmth, and authority — whether you intend to or not. Most people have never measured a single signal.',
};

export const REVELATION = {
  headline: '11 Hidden Signals',
  subheadline: 'In every word you speak.',
  signals: [
    'Confidence', 'Warmth', 'Authority', 'Nervousness',
    'Sarcasm', 'Passion', 'Empathy', 'Curiosity',
    'Excitement', 'Certainty', 'Friendliness',
  ],
};

export const HOW_IT_WORKS = {
  headline: 'Three Steps to Clarity',
  steps: [
    {
      number: '01',
      title: 'Record',
      description: 'Tap and speak. 30 seconds is all it takes.',
      icon: 'mic',
    },
    {
      number: '02',
      title: 'Analyze',
      description: '25 peer-reviewed acoustic models decode your voice in real-time.',
      icon: 'waveform',
    },
    {
      number: '03',
      title: 'Improve',
      description: 'Get your scores, see what to fix, and track your progress over time.',
      icon: 'chart',
    },
  ],
};

export const FEATURES = [
  {
    id: 'charisma',
    title: 'Your Charisma Score',
    description: 'A single number (0–100) that captures how confident, warm, and energetic you sound. Finally know where you stand.',
    icon: '✦',
  },
  {
    id: 'detection',
    title: 'Nervousness Detection',
    description: 'AI spots vocal tremors, pace irregularities, and tension patterns before anyone else notices — including you.',
    icon: '◎',
  },
  {
    id: 'coaching',
    title: 'Personalized Coaching',
    description: 'No generic tips. Specific, actionable fixes based on your unique voice patterns. Practice exercises included.',
    icon: '⟐',
  },
  {
    id: 'tracking',
    title: 'Progress Over Time',
    description: 'Every recording builds your voice profile. Watch your scores improve session after session.',
    icon: '↗',
  },
];

export const TESTIMONIALS = [
  {
    quote: "Scary accurate. It caught anxiety I didn't even know was there.",
    author: 'Sarah Chen',
    role: 'YouTube Creator',
  },
  {
    quote: "I used this before my TEDx talk. My confidence score went from 62 to 89 in two weeks.",
    author: 'Marcus Rivera',
    role: 'Public Speaker',
  },
  {
    quote: "Game changer for sales calls. I can actually see what's working and what's not.",
    author: 'Priya Sharma',
    role: 'Startup Founder',
  },
];

export const STATS = [
  { value: '10k+', label: 'Voice analyses completed' },
  { value: '4.9★', label: 'App Store rating' },
  { value: '25', label: 'Peer-reviewed studies powering the AI' },
];

export const FAQ = [
  {
    q: 'Is my voice data private?',
    a: 'Yes. All analysis happens on-device. Your recordings never leave your phone unless you explicitly choose to share them.',
  },
  {
    q: 'How accurate is it?',
    a: 'Creator Voice uses 25 peer-reviewed acoustic models from Stanford speech labs and clinical voice researchers. It\'s the same science used in professional voice assessment.',
  },
  {
    q: 'How long does analysis take?',
    a: 'About 30 seconds of recording, then instant results. You\'ll have your full voice profile in under a minute.',
  },
  {
    q: 'Is there a free tier?',
    a: 'Yes. Your first analysis is completely free — no credit card required. See your scores before deciding to subscribe.',
  },
];

export const FINAL_CTA = {
  headline: 'Stop Wondering.\nStart Knowing.',
  subheadline: 'Your first analysis is free. See what your voice has been saying without you.',
};
